import Http from '../../../../Http/Http'
import {
    SyndicationCatalogResponse,
    SyndicationParamsResponse,
    SyndicationPlaylistResponse,
    SyndicationResponse,
    SyndicationTagsResponse,
    SyndicationUpdateResponse
} from '../Model/VerticalContentModel'
import {Tag, TagResponse} from "../../../../Mesvideo/models/MesvideoModel"
const http = new Http()

export class VerticalContentService {
    getSyndication(): Promise<SyndicationResponse> {
        return http.get<SyndicationResponse>(`syndication/verticalContents`).then(response => response.data)
    }
    getSyndicationParams(id: string | number, type: string): Promise<SyndicationParamsResponse[]> {
        return http.get<SyndicationParamsResponse[]>(`syndication/verticalContents/${type}/${id}`).then(response => response.data)
    }
    getSyndicationCatalog(idSite: string): Promise<SyndicationCatalogResponse> {
        return http.get<SyndicationCatalogResponse>(`syndication/catalogs?site=${idSite}`).then(response => response.data)
    }
    getSyndicationPlaylist(idSite: string): Promise<SyndicationPlaylistResponse> {
        return http.get<SyndicationPlaylistResponse>(`syndication/playlists?site=${idSite}`).then(response => response.data)
    }
    updateSyndication(type: string, id: number | string, idSite: string, subscribed: boolean): Promise<SyndicationUpdateResponse> {
        const bodyParams = { site: idSite, subscribed: subscribed }
        return http.put<SyndicationUpdateResponse>(`syndication/${type}/${id}`, bodyParams).then(response => response.data)
    }
    getSyndicationTags(idSite: string, search?: string): Promise<TagResponse[]> {
        const query = search && search.length >= 3 ? `&search=${encodeURIComponent(search)}` : ''
        return http.get<TagResponse[]>(`syndication/tags?site=${idSite}${query}`)
            .then(res => res.data)
    }
    


}
